import styled from 'styled-components';
import { FillSpaceContainer } from '../Containers';

import { breakpoints } from '../../constants';

export const InstructionSvgWrapper = styled(FillSpaceContainer)`
    svg {
        height: 100%;
        width: auto;

        @media (${breakpoints.mediumMin}) {
            padding: 100px 100px 0 100px;
        }
    }
`;
